import { createContext, useContext, useState } from 'react';

const Context = createContext({});

export function DialogProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState();
  const [title, setTitle] = useState('');

  function openDialog(title, content) {
    setOpen(true);
    setContent(content);
    setTitle(title);
  }

  function closeDialog() {
    setOpen(false);
    setContent(undefined);
    setTitle('');
  }

  return (
    <Context.Provider
      value={{ isOpen: open, openDialog, closeDialog, title, content }}
    >
      {children}
    </Context.Provider>
  );
}

export function useDialogContext() {
  return useContext(Context);
}
